import SiQuestionMarkCircle from '@/icons/SiQuestionMarkCircle';
import { FC } from 'react';
import { Button } from '../form/Button';
import { ButtonVariant } from '../form/buttonHelper';

interface UserGuideButtonProps {
  newRoute: string;
}

export const UserGuideButton: FC<UserGuideButtonProps> = ({ newRoute }) => {
  const onClick = () => {
    window.open(`${window.location.origin}${newRoute}`);
  };

  return (
    <Button onClick={onClick} variant={ButtonVariant.Mono}>
      <SiQuestionMarkCircle className="text-xl" />
      <span>User Guide</span>
    </Button>
  );
};
